import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";
import {catchError} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {DocumentRequirement} from "../../models/document-requirement";
import {DocumentRequirementField} from "../../models/document-requirement_field";
import Helpers from "../../utils/helpers";

@Injectable()
export class DocumentRequirementControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRegistrationRequirements(registrationId: string): Observable<DocumentRequirement[]> {
    return this.http.get(this.baseUrl + "registration/" + registrationId + "/document_requirement") as  Observable<DocumentRequirement[]>;
  }

  public addRegistrationRequirement(registrationId: string, documentRequirement: DocumentRequirement): Observable<DocumentRequirementField> {
    Helpers.trimRecursiveObj(documentRequirement);
    const body = JSON.stringify(documentRequirement);
    return this.http.post(this.baseUrl + "registration/" + registrationId + "/document_requirement", body) as Observable<DocumentRequirementField>;
  }

  public addRegistrationRequirementField(documentRequirementId: string, documentRequirementField: DocumentRequirementField) {
    Helpers.trimRecursiveObj(documentRequirementField);
    const body = JSON.stringify(documentRequirementField);
    return this.http.post(this.baseUrl + "document_requirement/" + documentRequirementId + "/document_requirement_field", body);
  }

  public getRegistrationRequirement(documentRequirementId: string) {
    return this.http.get(this.baseUrl + "document_requirement/" + documentRequirementId);
  }

  public getRegistrationRequirementFields(documentRequirementId: string): Observable<DocumentRequirementField[]> {
    return this.http.get(this.baseUrl + "document_requirement/" + documentRequirementId + "/document_requirement_field") as Observable<DocumentRequirementField[]>;
  }

  public saveRegistrationRequirement(documentRequirement: DocumentRequirement) {
    Helpers.trimRecursiveObj(documentRequirement);
    const body = JSON.stringify(documentRequirement);
    return this.http.put(this.baseUrl + "document_requirement", body, {responseType: "text"});
  }

  public saveRegistrationRequirementField(documentRequirementField: DocumentRequirementField) {
    Helpers.trimRecursiveObj(documentRequirementField);
    const body = JSON.stringify(documentRequirementField);
    return this.http.put(this.baseUrl + "document_requirement_field", body, {responseType: "text"});
  }

  public deleteRegistrationRequirement(documentRequirementId: string) {
    return this.http.delete(this.baseUrl + "document_requirement/" + documentRequirementId, {responseType: "text"});
  }

  public deleteRegistrationRequirementField(documentRequirementFieldId: string) {
    return this.http.delete(this.baseUrl + "document_requirement_field/" + documentRequirementFieldId, {responseType: "text"});
  }

  public updateLinkingFileUploadPath(id: string, newValue: string) {
    const body = { linkingFileUploadPath: newValue };
    return this.http.patch(this.baseUrl + "document_requirement/" + id + "/linking_file_upload_path", body).pipe(
      catchError((error) => {
        if (error.status === 404) {
          return of(null);
        }
        throw error;
      })
    );
  }

  public updateSortOrder(registrationId, documentRequirements: DocumentRequirement[]) {
    const body = {};
    documentRequirements.forEach((a, index) => body[a.id] = index);
    return this.http.put(this.baseUrl  + "registration/" + registrationId + "/sort_document_requirements", body);
  }
}
